import { withInstall } from '@bigin/utils'
import Upload from './src/upload.vue'

export const BUpload = withInstall(Upload)
export default BUpload

export * from './src/upload'
export * from './src/upload-content'
export * from './src/upload-list'
export * from './src/upload-dragger'
